module.exports = __webpack_public_path__ + "static/media/list.10510095.svg";